import { createBatchedFetcher } from '../../lib/gqlFetcher_myf2b';
const uiDataFetcher = createBatchedFetcher(1000);
export default uiDataFetcher;
